module.exports = __webpack_public_path__ + "static/media/loading.c5590569.svg";


//////////////////
// WEBPACK FOOTER
// ./src/loading.svg
// module id = 149
// module chunks = 0